module.exports = __webpack_public_path__ + "img/mydessk-white.d4376df7.svg";